import { ModuleGroupModuleVersion } from '@xpo-ltl/sdk-moduleexecutor';

export class StepGridItem {
  constructor(
    public id: number,
    public name: string,
    public rows: ModuleGroupModuleVersion[],
    public removable: boolean,
    public execOrderLoopInd: boolean
  ) {}
}
